import { zafClient } from '@/services/zendesk'
import type { ZafMetadata } from '@/interfaces'
import type { VtexConversationMessage } from '@/interfaces'

export type { VtexConversationMessage }

export async function getVtexOrderConversation(orderId: string): Promise<VtexConversationMessage[]> {
  if (!zafClient) throw new Error('ZAF client not available')

  const meta = await zafClient.metadata() as unknown as ZafMetadata
  const { vtexAppSubdominio, vtexAppKey, vtexAppToken } = meta.settings

  const messages = await zafClient.request({
    url: `https://${vtexAppSubdominio}.vtexcommercestable.com.br/api/oms/pvt/orders/${orderId}/conversation-message`,
    type: 'GET',
    headers: {
      'X-VTEX-API-AppKey': vtexAppKey,
      'X-VTEX-API-AppToken': vtexAppToken,
    },
    dataType: 'json',
  }) as VtexConversationMessage[]

  return messages
}
